/**
 * 定義ファイル
 */
// BEサーバー
export const BASE_URL = "https://backend.dbarai-merchant.docomo.ne.jp/";

// SSO連携用URI
export const SSO_URL_GEN = "https://www.neo-mobico-nttdocomo.com/rpsite/login"; //検証環境 加盟店ユーザ
export const SSO_URL_DCM = "https://dcm.neo-mobico-nttdocomo.com/rpsite/login"; //検証環境 ドコモユーザ

/** サブドメイン */
export const SUB_DOMAIN_GENERAL = "dbarai-merchant.docomo.ne.jp";
export const SUB_DOMAIN_DCM = "dcm.dbarai-merchant.docomo.ne.jp";
export const SUB_DOMAIN_GW = "gw.dbarai-merchant.docomo.ne.jp";
